import React, { Suspense, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./List_view.css";

import InputRange from "react-input-range";
import Slider from "@material-ui/core/Slider";
import { makeStyles } from "@material-ui/core/styles";

import { FaEyeSlash } from "react-icons/fa";
import { BsCheck2 } from "react-icons/bs";

import { Col, Button, Form, FormGroup, Label, Input, Row } from "reactstrap";
import { BrowserRouter as Router, Link } from "react-router-dom";
import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import FilterNavbar from "../../DefaultLayout/FilterNavbar";

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

function List_view({ direction, ...args }) {
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
        <div className="filter-nav-wrapper">
          <FilterNavbar
            img1={<img src="assets/menu.png" alt="Group 13521" />}
            img2={<img src="assets/test.svg" alt="Group 13521" />}
            img3={<img src="assets/map.svg" alt="Group 13521" />}
          />
        </div>
      </Suspense>
      {/* <Row className="property-listing-index12 "> */}
      {/* <Col sm="12" className=" "> */}

      {/* </Col> */}
      {/* </Row> */}
      <div className="list-view-container">
        <div className="ls-main-white mb-4">
          <div className="row w-100">
            <div className="col-lg-5 col-md-12">
              <Link to="/property-info">
                <div className="view-card-main h-100">
                  <div className="icon-main-view list-icons">
                    <a>
                      <img src="assets/favourite.svg" alt="hshshs" />
                    </a>
                    <a>
                      <img src="assets/hidden.svg" alt="hshshs" />
                    </a>
                  </div>
                  <div className="img-view-main h-100">
                    <img src="assets/iamge2.jpg" alt="img1" />
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-7 col-md-12 pe-0 padding-div">
              <div className="desc-ls-main">
                <div className="main-ls-de">
                  <h3>Rekagrandi 6, 107 Reykjavík</h3>
                  <h4>Symptoms _ = View</h4>
                  <h4>Registered: June 22, 2022</h4>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="ls-bt-ds">
                    <p>
                      3 herb. - 75m² -flatable - Available stax - Long term
                      rental
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-12">
                  <div className="pr-ls-dsc">
                    <div className="main-dd-ls">
                      <h2>Price : kr. 210,000 per month.</h2>
                    </div>

                    <div className="dd-ll-ss">
                      <div className="setup-ls d-flex">
                        <h2>Included:</h2>
                        <p>Electricity + heating + (housing)</p>
                      </div>

                      <div className="setup-ls d-flex pt-1">
                        <h2>House fund:</h2>
                        <p>None</p>
                      </div>

                      <div className="main-dd-ls pt-3">
                        <h2>Liability insurance:</h2>
                      </div>

                      <div className="setup-ls d-flex">
                        <h2>Bank guarantee:</h2>
                        <p>6,00,000, or</p>
                      </div>

                      <div className="setup-ls d-flex pt-1">
                        <h2>Rental protection:</h2>
                        <p>Yes/`No</p>
                        <p>6,00,000</p>
                      </div>

                      <div className="bottom-dd-con pt-4 mb-4">
                        <Link to="/filter-3">
                          <button>
                            <h2>Description:</h2>
                            <span>Click to see description (read more)</span>
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8 col-md-12 col-12   ">
                  <div className="row d-flex">
                    <div className="pr-ls-dsc-con col-lg-5 col-md-6 col-6">
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Pets</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Furniture</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Smoking</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span> Garage</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Elevator</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Storage</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Trimming</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Co-tenant</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Charging station f. electric cars</span>
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>
                    <div className="last-nox-pr col-lg-7 col-md-6 col-6 ">
                      <div className="main-dd-ls ">
                        <h2>Landlord:</h2>
                        <div className="setup-ls d-flex">
                          <h2>Name:</h2>
                          <p>Björg María Oddsdóttir</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Phone:</h2>
                          <p>8674108</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Email:</h2>
                          <p>Björg María Oddsdóttir</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Contact:</h2>
                          <p>Allan daginn</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ls-main-white mb-4">
          <div className="row w-100">
            <div className="col-lg-5 col-md-12">
              <Link to="/property-info">
                <div className="view-card-main h-100">
                  <div className="icon-main-view list-icons">
                    <a>
                      <img src="assets/favourite.svg" alt="hshshs" />
                    </a>
                    <a>
                      <img src="assets/hidden.svg" alt="hshshs" />
                    </a>
                  </div>
                  <div className="img-view-main h-100">
                    <img src="assets/iamge2.jpg" alt="img1" />
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-7 col-md-12 pe-0 padding-div">
              <div className="desc-ls-main">
                <div className="main-ls-de">
                  <h3>Rekagrandi 6, 107 Reykjavík</h3>
                  <h4>Symptoms _ = View</h4>
                  <h4>Registered: June 22, 2022</h4>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="ls-bt-ds">
                    <p>
                      3 herb. - 75m² -flatable - Available stax - Long term
                      rental
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-12">
                  <div className="pr-ls-dsc">
                    <div className="main-dd-ls">
                      <h2>Price : kr. 210,000 per month.</h2>
                    </div>

                    <div className="dd-ll-ss">
                      <div className="setup-ls d-flex">
                        <h2>Included:</h2>
                        <p>Electricity + heating + (housing)</p>
                      </div>

                      <div className="setup-ls d-flex pt-1">
                        <h2>House fund:</h2>
                        <p>None</p>
                      </div>

                      <div className="main-dd-ls pt-3">
                        <h2>Liability insurance:</h2>
                      </div>

                      <div className="setup-ls d-flex">
                        <h2>Bank guarantee:</h2>
                        <p>6,00,000, or</p>
                      </div>

                      <div className="setup-ls d-flex pt-1">
                        <h2>Rental protection:</h2>
                        <p>Yes/`No</p>
                        <p>6,00,000</p>
                      </div>

                      <div className="bottom-dd-con pt-4 mb-4">
                        <Link to="/filter-3">
                          <button>
                            <h2>Description:</h2>
                            <span>Click to see description (read more)</span>
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8 col-md-12 col-12   ">
                  <div className="row d-flex">
                    <div className="pr-ls-dsc-con col-lg-5 col-md-6 col-6">
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Pets</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Furniture</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Smoking</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Garage</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Elevator</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Storage</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Trimming</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Co-tenant</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Charging station f. electric cars</span>
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>
                    <div className="last-nox-pr col-lg-7 col-md-6 col-6 ">
                      <div className="main-dd-ls">
                        <h2>Landlord:</h2>
                        <div className="setup-ls d-flex">
                          <h2>Name:</h2>
                          <p>Björg María Oddsdóttir</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Phone:</h2>
                          <p>8674108</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Email:</h2>
                          <p>Björg María Oddsdóttir</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Contact:</h2>
                          <p>Allan daginn</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ls-main-white mb-4">
          <div className="row w-100">
            <div className="col-lg-5 col-md-12">
              <Link to="/property-info">
                <div className="view-card-main h-100">
                  <div className="icon-main-view list-icons">
                    <a>
                      <img src="assets/favourite.svg" alt="hshshs" />
                    </a>
                    <a>
                      <img src="assets/hidden.svg" alt="hshshs" />
                    </a>
                  </div>
                  <div className="img-view-main h-100">
                    <img src="assets/iamge2.jpg" alt="img1" />
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-lg-7 col-md-12 pe-0 padding-div">
              <div className="desc-ls-main">
                <div className="main-ls-de">
                  <h3>Rekagrandi 6, 107 Reykjavík</h3>
                  <h4>Symptoms _ = View</h4>
                  <h4>Registered: June 22, 2022</h4>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="ls-bt-ds">
                    <p>
                      3 herb. - 75m² -flatable - Available stax - Long term
                      rental
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-12">
                  <div className="pr-ls-dsc">
                    <div className="main-dd-ls">
                      <h2>Price : kr. 210,000 per month.</h2>
                    </div>

                    <div className="dd-ll-ss">
                      <div className="setup-ls d-flex">
                        <h2>Included:</h2>
                        <p>Electricity + heating + (housing)</p>
                      </div>

                      <div className="setup-ls d-flex pt-1">
                        <h2>House fund:</h2>
                        <p>None</p>
                      </div>

                      <div className="main-dd-ls pt-3">
                        <h2>Liability insurance:</h2>
                      </div>

                      <div className="setup-ls d-flex">
                        <h2>Bank guarantee:</h2>
                        <p>6,00,000, or</p>
                      </div>

                      <div className="setup-ls d-flex pt-1">
                        <h2>Rental protection:</h2>
                        <p>Yes/`No</p>
                        <p>6,00,000</p>
                      </div>

                      <div className="bottom-dd-con pt-4 mb-4">
                        <Link to="/filter-3">
                          <button>
                            <h2>Description:</h2>
                            <span>Click to see description (read more)</span>
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8 col-md-12 col-12   ">
                  <div className="row d-flex">
                    <div className="pr-ls-dsc-con col-lg-5 col-md-6 col-6">
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Pets</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Furniture</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Smoking</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Garage</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/cross.svg" />
                              <span>Elevator</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Storage</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Trimming</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Co-tenant</span>
                            </span>
                          </a>
                        </p>
                      </div>
                      <div class="setting-links">
                        <p>
                          <a>
                            <span class="d-flex cus-space list-icons1">
                              <img src="assets/tick.svg" />
                              <span>Charging station f. electric cars</span>
                            </span>
                          </a>
                        </p>
                      </div>
                    </div>
                    <div className="last-nox-pr col-lg-7 col-md-6 col-6 ">
                      <div className="main-dd-ls">
                        <h2>Landlord:</h2>
                        <div className="setup-ls  d-flex">
                          <h2>Name:</h2>
                          <p>Björg María Oddsdóttir</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Phone:</h2>
                          <p>8674108</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Email:</h2>
                          <p>Björg María Oddsdóttir</p>
                        </div>
                        <div className="setup-ls d-flex">
                          <h2>Contact:</h2>
                          <p>Allan daginn</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}

export default List_view;
